import React from "react";
import BioReformCard from "./common/BioReformCard";
import ImageCards from "./common/ImageCards";
import CardBlock from "./common/CardBlock";
import Badge from "./common/bagde";

const Steppers = () => {

  
  return (
    <>
      <div className="relative md:bottom-14 bottom-0 pt-8">
        <div className="main-container mx-auto">
          <p className="pb-8 text-[#233751] font-bold md:text-[48px] text-[32px] text-center bold-font">
            Here's what you get inside
          </p>
          <div className="flex items-center justify-center">
            <div className="overflow-hidden max-w-2xl w-full">
              <div className="text-black flex items-center gap-4 justify-center md:px-4 px-6">
                <div className="relative">
                  <div className="bg-[#233751] w-14 h-14 rounded-[6px] flex items-center justify-center">
                    <span className="text-white text-sm font-semibold absolute top-4 left-1/3 transform -translate-x-1/2">
                      #
                    </span>
                    <span className="text-white text-3xl font-bold">1</span>
                  </div>
                </div>

                <h2 className="text-xl md:text-[24px] font-bold text-[#233751] bold-font">
                  BULLETPROOF your IMMUNITY with: "Lung Immune"
                </h2>
              </div>
              <Badge price="$99.95" variant="gold" />
            </div>
          </div>
          <div className="p-4">
            <div className="max-w-6xl mx-auto overflow-hidden md:px-10 px-0">
              <div className="">
                <div className="flex flex-col-reverse md:flex-row items-center">
                  <div className="md:w-2/3 md:pr-6 pr-0 text-[20px] font-normal md:pt-0 pt-4">
                    <p className="mb-4 text-[#000000]">
                      It's more essential than ever to have a rock-solid immune
                      system that keeps you healthy, sharp, and energetic.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Especially since we're exposed to more health threats than
                      ever.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      I'm not just talking about the air we breathe.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      I'm talking about health threats in our water and food
                      supply...
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Along with the constant threat of deadly flu and toxic
                      viruses that can spread like wildfire around the world in
                      a matter of days.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      That's exactly why Lung Immune is the foundation of my
                      Vitality Box.
                    </p>
                    <div className="mb-4">
                      <p className="font-bold text-[24px] mb-2 bold-font text-[#233751]">
                        Every Lung Immune capsule contains 1100mg of 9
                        immunity-boosting nutrients.
                      </p>
                    </div>
                    <p className="mb-4 text-[#000000]">
                      As just one example, Echinacea is one of nature's most
                      powerful and effective ingredients.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      It's proven by numerous studies to increase white blood
                      cell production. This helps fight off these modern-day
                      health threats like viruses, bacteria, and flu...
                    </p>
                    <p className="mb-4 text-[#000000]">
                      And it helps prevent respiratory infections, keeping you
                      healthy from the unpredictable toxins we all face.
                    </p>
                  </div>
                  <div className="md:w-2/5 flex flex-col items-center">
                    <div>
                      <img
                        src="https://cdn.blackincae.com/5OL-lung-immune-l-otto.png"
                        alt="Lung Immune Product"
                        className="w-full rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="pt-6">
                <div className="flex flex-col md:flex-row items-center gap-8">
                  <div className="md:w-1/3 flex flex-col">
                    <div className="mb-4 hidden md:block">
                      <img
                        src="https://cdn.blackincae.com/xkC-lungfx-l-otto.png"
                        alt="Lung Immune Product"
                        className="w-full rounded-lg"
                      />
                    </div>
                    <div className="mb-4 block md:hidden">
                      <img
                        src="https://cdn.blackincae.com/j6A-image_fx-3-1-1-.png"
                        alt="Lung Immune Product"
                        className="w-full rounded-lg"
                      />
                    </div>
                  </div>
                  <div className="md:w-2/3 md:pr-6 pr-0 text-[20px] font-normal">
                    <p className="mb-4 text-[#000000]">
                      Echinacea is also full of “alkamides”.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      These boost antioxidant activity further, strengthening
                      immune response as well as reducing oxidative stress.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      What’s more, Echinacea has been found to reduce the
                      duration of colds by more than 50%! 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      And that’s just one of the 9 immunity-boosting nutrients
                      in every capsule of
                      <span className="bold-font text-[#233751]">
                        {" "}
                        Lung Immune!{" "}
                      </span>
                    </p>
                    <p className="mb-4 text-[#000000]">
                      With
                      <span className="bold-font text-[#233751]">
                        {" "}
                        Lung Immune{" "}
                      </span>
                      by your side, you’ll rest easy knowing you’re giving your
                      immune system the nutrients it needs to fight off the
                      ever-increasing threats to your health and well-being.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      This is especially essential if you’re over the age of
                      40… 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      When your immune system needs more support than ever. 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      With
                      <span className="bold-font text-[#233751]">
                        {" "}
                        Lung Immune{" "}
                      </span>
                      you’ll bulletproof your immunity AND your peace of mind.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="bg-gray-skew">
        <div className="main-container mx-auto">
          <div className="flex items-center justify-center">
            <div className="overflow-hidden max-w-2xl w-full px-6 pt-4 md:pt-0">
              <div className="text-black flex items-center gap-4 justify-center">
                <div className="relative">
                  <div className="bg-[#233751] w-14 h-14 rounded-[6px] flex items-center justify-center">
                    <span className="text-white text-3xl font-semibold">#</span>
                    <span className="text-white text-3xl font-bold">2</span>
                  </div>
                </div>
                <div className="text-xl md:text-[24px] font-bold text-[#233751] text-start max-w-7xl bold-font">
                  Support HEALTHY Bacteria Balance with: “BioReform ProBiotic” -
                  with MAKTrek™ Technology
                </div>
              </div>
              <Badge price="$149.95" variant="gold" />
            </div>
          </div>
          <div className="p-4">
            <div className="max-w-6xl mx-auto overflow-hidden md:px-10 px-0">
              <div className="">
                <div className="flex flex-col-reverse md:flex-row items-center">
                  <div className="md:w-2/3 md:pr-6 pr-0 text-[20px] font-normal text-start md:pt-0 pt-4">
                    <p className="mb-4 text-[#000000]">
                      Most people don’t understand how modern life is waging a
                      constant war on the “good bacteria” that help us stay
                      healthy.
                    </p>
                    <p className="mb-4 text-[#000000] flex items-center gap-3">
                      <img src="../src/assets/images/crossxx.svg" alt="" />
                      <span>From processed food to pollution… </span>
                    </p>
                    <p className="mb-4 text-[#000000] flex items-center gap-3">
                      <img src="../src/assets/images/crossxx.svg" alt="" />
                      <span>From lack of sleep and lack of exercise… </span>
                    </p>
                    <p className="mb-4 text-[#000000] flex items-center gap-3">
                      <img src="../src/assets/images/crossxx.svg" alt="" />
                      <span>To too much stress and exposure to toxins.</span>
                    </p>
                    <p className="mb-4 text-[#000000]">
                      That’s why I developed
                      <span className="bold-font">“BioReform Probiotic.”</span>
                    </p>
                    <p className="mb-4 text-[#000000]">
                      With 4 ULTRA-broad spectrum super-probiotic strains,
                      <span className="bold-font">
                        “BioReform Probiotic.”
                      </span>{" "}
                      is a crucial part of improving your bacterial balance.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      This has a direct impact on the strength of your gut
                      health AND your respiratory health.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Inside every capsule, you’ll benefit from 20 Billion CFUs
                      (colony-forming units) - that’s 5x more than leading
                      brands! 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      This helps boost your “good” bacteria and helps flush out
                      the “bad bacteria” living in your gut… 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Which, in turn, helps support your respiratory health. 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Plus, it helps optimize gut health, digestion, and mood.
                    </p>
                  </div>
                  <div className="md:w-2/5 flex flex-col items-center">
                    <div className="mb-4">
                      <img
                        src="https://cdn.blackincae.com/vVP-bioreform-l-otto.png"
                        alt="Lung Immune Product"
                        className="w-full rounded-lg "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BioReformCard />
          <div className="text-black flex items-center gap-4 justify-center pt-12 px-4">
            <div className="text-[20px] text-center max-w-xl">
              With BioReform Probiotic, you’ll balance the micro-organisms that
              boost your mood, digestion, immunity, and energy.
            </div>
          </div>
          <div className="text-black flex items-center gap-4 justify-center py-8 px-4">
            <div className="text-[20px] text-center max-w-xl">
              Our patented MAKTrek technology guarantees it’s the most potent
              probiotic you can take.
            </div>
          </div>
        </div>
      </div>
      <div className="relative bg-left bg-no-repeat bg-contain md:bg-[url('https://cdn.blackincae.com/9tI-bone-l-otto.png')] bottom-8">
        <div className="main-container mx-auto">
          <div className="flex items-center justify-center">
            <div className="overflow-hidden max-w-2xl w-full">
              <div className="hidden md:block">
                <div className="text-black flex items-center gap-4 justify-center md:mt-0 mt-8 pt-10">
                  <div className="relative">
                    <div className="bg-[#233751] w-14 h-14 rounded-[6px] flex items-center justify-center">
                      <span className="text-white text-3xl font-semibold">
                        #
                      </span>
                      <span className="text-white text-3xl font-bold">3</span>
                    </div>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                    REPAIR Tissue, Skin, & Bones with: <br />
                    “Bone Renew Multi Collagen”
                  </div>
                </div>
              </div>
              <div className="text-black flex items-center gap-4 justify-center md:mt-0 mt-8 pt-10 block md:hidden px-6">
                <div className="relative">
                  <div className="bg-[#233751] w-14 h-14 rounded-[6px] flex items-center justify-center">
                    <span className="text-white text-3xl font-semibold">#</span>
                    <span className="text-white text-3xl font-bold">3</span>
                  </div>
                </div>
                <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                  REPAIR Tissue, Skin, & Bones with: “Bone Renew Multi Collagen”
                </div>
              </div>
              <Badge price="$112.95" variant="gold" />
            </div>
          </div>
          <div className="">
            <div className="max-w-6xl mx-auto overflow-hidden md:px-10 px-4">
              <div className="">
                <div className="flex flex-col-reverse md:flex-row pt-4">
                  <div className="md:w-2/3 md:pr-6 pr-0 text-[20px] font-normal md:pt-0">
                    <p className="mb-4 text-[#000000]">
                      After we reach 40 years old, our skin tissue and bone
                      health quickly weaken because of declining collagen
                      production.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      But when you add a daily capsule of{" "}
                      <span className="bold-font">
                        Bone Renew Multi Collagen,
                      </span>
                      you can replace and rebuild lost collagen. 
                    </p>
                    <p className="mb-4 text-[#000000]">
                      This helps keep lung tissue healthy and able to defend
                      against the airborne toxins in our environment.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      Plus,
                      <span className="bold-font">
                        {" "}
                        Bone Renew Multi Collagen{" "}
                      </span>
                      boosts skin health and helps repair your bones. 
                    </p>
                    <div className="block md:hidden flex items-center justify-center">
                      <img src="../src/assets/images/bones-sm.png" alt="" />
                    </div>
                    <p className="my-4 text-[#000000]">
                      <span className="bold-font">
                        {" "}
                        Bone Renew Multi Collagen{" "}
                      </span>
                      plays a vital role in preserving vitality in your body’s
                      tissue, skin, and bones.
                    </p>
                    <p className="mb-4 text-[#000000]">
                      In fact, one study suggested that a daily intake of as
                      little as 10 grams of collagen can reduce bone loss,
                      simultaneously alleviating discomfort in knees, hips, and
                      joints.
                    </p>
                    <p className="mb-4 text-[#000000] md:pb-[160px] pb-[0px]">
                      <span className="bold-font">
                        {" "}
                        Bone Renew Multi Collagen{" "}
                      </span>
                      will become your trusted guardian for your active and
                      vibrant lifestyle for years to come.
                    </p>
                  </div>
                  <div className="md:w-2/5 flex flex-col items-center">
                    <div className="mb-4">
                      <img
                        src="https://cdn.blackincae.com/yV1-bonerenew-l-otto.png"
                        alt="Lung Immune Product"
                        className="w-full rounded-lg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative md:bottom-[120px] bottom-0 min-h-[1850px]">
        <svg
          className="absolute inset-0 w-full h-full"
          viewBox="0 0 1440 1892"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
        >
          <path
            d="M0 86.2265C564.273 -26.3436 879.647 -31.116 1440 86.2265V1827C880.502 1701.33 565.166 1703.82 0 1827V86.2265Z"
            fill="#FAFAFA"
          />
        </svg>
        <div className="second-bg-gray-skew">
          <div className="main-container mx-auto">
            <div className="flex items-center justify-center">
              <div className="overflow-hidden max-w-2xl w-full">
                <div className="text-black flex items-center gap-4 md:justify-center justify-start px-6 pt-16">
                  <div className="relative">
                    <div className="bg-[#233751] w-14 h-14 rounded-[6px] flex items-center justify-center">
                      <span className="text-white text-3xl font-semibold">
                        #
                      </span>
                      <span className="text-white text-3xl font-bold">4</span>
                    </div>
                  </div>
                  <div className="hidden md:block">
                    <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                      Optimize Recovery With: “Bedtime Reset”
                    </div>
                  </div>
                  <div className="block md:hidden">
                    <div className="text-xl md:text-2xl font-bold text-[#233751] text-start max-w-md bold-font">
                      Optimize Recovery With: <br />
                      “Bedtime Reset”
                    </div>
                  </div>
                </div>
                <Badge price=" $139.95" variant="blue" />
              </div>
            </div>
            <div className="p-4">
              <div className="max-w-6xl mx-auto overflow-hidden md:px-10 px-0">
                <div className="">
                  <div className="flex flex-col-reverse md:flex-row items-center">
                    <div className="md:w-2/3 md:pr-6 pr-0 text-[20px] font-normal text-start md:pt-0 pt-4">
                      <p className="mb-4 text-[#000000]">
                        We’ve saved the best until the last!
                      </p>
                      <p className="mb-4 text-[#000000]">
                        See, when you don’t have the energy to do the things you
                        love in life… 
                      </p>
                      <p className="mb-4 text-[#000000]">
                        It impacts everything: relationships, fitness,
                        activities, and overall health.
                      </p>
                      <p className="mb-4 text-[#000000]">
                        Since our proprietary “Bedtime Reset” formula helps you
                        optimize your body’s rest and recovery…
                      </p>
                      <p className="mb-4 text-[#000000]">
                        <span className="bold-font">
                          You’ll soon be getting the best sleep of your life -
                          100% naturally.
                        </span>
                      </p>
                      <p className="mb-4 text-[#000000]">
                        That way, you’ll have energy to spare to do the things
                        you love each and every day.
                      </p>
                      <p className="mb-4 text-[#000000]">
                        Inside each dose, you'll get clinically proven and
                        time-tested nutrients for optimizing rest, recovery, and
                        deep, restful sleep…
                      </p>
                    </div>
                    <div className="md:w-1/3 flex flex-col items-center">
                      <div className="mb-4">
                        <img
                          src="https://cdn.blackincae.com/HtB-bedtime-l-otto.png"
                          alt="Lung Immune Product"
                          className="w-full rounded-lg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ImageCards />
            <CardBlock />
            <div className="w-full">
              <span className="w10gift-highlight-yellow italic bold-font text-[#233751]">
                You. Are. Going. To. LOVE. It.
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Steppers;
